function getPreviousMonthLastDays(
  monthIndex: number,
  fullYear: number,
  amountOfDays: number
) {
  const lastDayOfPreviousMonth = new Date(fullYear, monthIndex, 0);
  const previousMonthYear = lastDayOfPreviousMonth.getFullYear();
  const previousMonthIndex = lastDayOfPreviousMonth.getMonth();
  const previousMontAmountOfDays = lastDayOfPreviousMonth.getDate();

  const previousMonthList: Date[] = [];

  for (let i = 0; i < amountOfDays; i++) {
    previousMonthList.push(
      new Date(
        previousMonthYear,
        previousMonthIndex,
        previousMontAmountOfDays - amountOfDays + 1 + i,
        0,
        0,
        0,
        0
      )
    );
  }

  return previousMonthList;
}

function getAmountOfDays(month: number, year: number) {
  const lastDay = new Date(year, month + 1, 0);
  return lastDay.getDate();
}

function populateMatrix(month: number, year: number) {
  const firstDay = new Date(year, month, 1);
  const firstDayIndex = firstDay.getDay();

  const numberOfDays = getAmountOfDays(month, year);

  const matrixWidth = 7;
  const matrixHeight = 5;
  const matrixSize = matrixWidth * matrixHeight;
  const remainingDaysToFill = matrixSize - numberOfDays;

  let previousMonthList: Date[] = [];
  if (firstDayIndex > 0) {
    previousMonthList = getPreviousMonthLastDays(month, year, firstDayIndex);
  }

  const numberOfDaysNextMonth =
    remainingDaysToFill - firstDayIndex > 0
      ? remainingDaysToFill - firstDayIndex
      : 0;

  const monthList = getDaysFromMonthAndYear(
    month,
    year,
    numberOfDays + numberOfDaysNextMonth
  );
  const finalMonthList = previousMonthList.concat(monthList);

  const matrix: Date[][] = [];
  for (let i = 0; i < finalMonthList.length; i += matrixWidth) {
    matrix.push(finalMonthList.slice(i, i + matrixWidth));
  }

  return matrix;
}

function shouldDisablePastMonth(date: string) {
  const activeDate = new Date(date);
  const activeMonth = activeDate.getMonth();
  const activeYear = activeDate.getFullYear();

  const currMonth = new Date().getMonth();
  const currYear = new Date().getFullYear();

  return currMonth === activeMonth && currYear === activeYear;
}

function getDaysFromMonthAndYear(
  monthIndex: number,
  fullYear: number,
  daysInMonth: number
) {
  const dateList: Date[] = [];
  for (let i = 1; i <= daysInMonth; i++) {
    const day = new Date(fullYear, monthIndex, i, 0, 0, 0, 0);
    dateList.push(day);
  }

  return dateList;
}

const formatDateToString = (date: Date) => {
  return date.toISOString().split("T")[0];
};

export {
  populateMatrix,
  getDaysFromMonthAndYear,
  getPreviousMonthLastDays,
  formatDateToString,
  getAmountOfDays,
  shouldDisablePastMonth,
};
